export default __webpack_public_path__ + "static/media/balcon.71c37a8e.png";